import { Controller } from "@hotwired/stimulus";

// The carry-over checklist in the Duplicate and New course modals (TMS-1586). Every
// option starts ticked each time the modal opens, and credit hours follow the
// accreditation they live on: they cannot come over without it. The server enforces
// the same rule (Lxp::CourseBuilder::CarryOver), so this only keeps the form honest.
export default class extends Controller {
  static targets = ["option"];

  reset() {
    this.optionTargets.forEach((option) => { option.checked = true; });
    this.sync();
  }

  sync() {
    const accreditation = this.option("accreditation");
    const creditHours = this.option("credit_hours");
    if (!accreditation || !creditHours) return;

    creditHours.disabled = !accreditation.checked;
    if (!accreditation.checked) creditHours.checked = false;
  }

  option(key) {
    return this.optionTargets.find((option) => option.dataset.option === key);
  }
}
